module.exports = __webpack_public_path__ + "img/icon_star_provider.ebb98df0.svg";